export const numberFormatter = (number: string | number) => {
  let formetedNumber = Number(number)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&\'');
  const splitArray = formetedNumber.split('.');

  if (splitArray.length > 1) {
    formetedNumber = splitArray[0];
  }

  return formetedNumber;
};

export const numberReFormatter = (number: string | number) => {
  const formetedNumber = String(number).replace(/'/g, '');

  return formetedNumber;
};

export const numericValues = (value: string) => {
  const formetedValue = value?.replace(/[^0-9.]/g, '') || '';

  return formetedValue;
};

export const cleanString = (value: string) => {
  if (value) {
    return value.replace(/ /g, '').toLocaleLowerCase();
  }

  return '';
};

export function checkIfImageExists(
  url: string,
  callback: (exists: boolean) => void,
) {
  const img = new Image();
  img.src = url;

  if (img.complete) {
    callback(true);
  } else {
    img.onload = () => {
      callback(true);
    };

    img.onerror = () => {
      callback(false);
    };
  }
}

export const excelRound = (value: number) => Math.floor(Math.pow(10, 2) * value + 0.5) * Math.pow(10, -2);

export const unMaskInput = (value: string) => {
  const changeCommaToDot = value?.replace(',', '.');
  const formetedValue = changeCommaToDot?.replace(/[^0-9.]/g, '') || '';

  return formetedValue;
};

export const maskValueHelper = (number: number) => {
  let formattedNumber = number.toLocaleString('en', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  // If the formatted number contains commas, replace commas with single quotes for integer part only
  if (formattedNumber.includes(',')) {
    // Remove commas
    formattedNumber = formattedNumber.replace(/,/g, '');

    // Insert single quotes for thousands separator
    formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, '\'');
  }

  return formattedNumber;
};

export const unMaskInputValue = (value: string) => {
  const changeCommaToDot = value && `${value}`.replace('.', ',');

  return changeCommaToDot;
};

export const mtHaToTonAc = (value: number) => {
  const result = (value * 1) / 0.9072 / 2.47105;

  return Math.round((result + Number.EPSILON) * 100) / 100;
};

export const haToAc = (value: number) => {
  const result = (value * 1) / 0.453592 / 2.47105;

  return Math.round((result + Number.EPSILON) * 100) / 100;
};

export const kgToLb = (value: number) => {
  const result = (value * 1) / 0.453592;

  return Math.round((result + Number.EPSILON) * 100) / 100;
};

export const mtTot = (value: number) => {
  const result = (value * 1) / 0.9072;

  return Math.round((result + Number.EPSILON) * 100) / 100;
};

export const HaToacOnly = (value: number) => {
  const result = value * 2.471;

  return Math.round((result + Number.EPSILON) * 100) / 100;
};

export const toHHMMSS = (secs: number) => new Date(secs * 1000).toISOString().slice(14, 19);

export const generateId = () => new Date().getTime() + Math.random();

export const persistWebViewLoadingInformation = () => {
  if ((window as any)?.ReactNativeWebView) {
    localStorage.setItem('isFirstLaunchWebViewDone', 'true');
  }
};

export const getCellFontColor = (value: number | string) => {
  if (!value) {
    return;
  }

  const valueModified = value !== '-' ? Number(value?.toString().replace(/'/g, '').replace(/,/g, '.')) : '-';

  if (typeof valueModified === 'string') {
    if (valueModified.charAt(0) === '-') {
      return 'rgba(248, 120, 27, 1)';
    }

    return 'rgba(17, 172, 107, 1)';
  }

  if (typeof valueModified === 'number' && valueModified < 0) {
    return 'rgba(248, 120, 27, 1)';
  }

  if (typeof valueModified === 'number' && valueModified === 0) {
    return 'rgba(0, 0, 0, 1)';
  }

  return 'rgba(17, 172, 107, 1)';
};

export const makeId = (length: number) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;

  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }

  return result;
};

export const cmToFineDry = (value: number) => value / 100 * 1.5 * 10000;

export const formatToTwoDecimals = (value: string) => {
  if (!value) {
    return value;
  }

  const numValue = parseFloat(value.replace(',', '.'));

  if (isNaN(numValue)) {
    return value;
  }

  return numValue.toFixed(2).replace('.', ',');
};